import React,  { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Loading from './Loading';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { postResult } from "./utils";

const activities = [{
  "key": "collections",
  "label": "I want to help with masjid collections (at other Masjids)",
  "options": [{
    "key": "jmic",
    "label": `(Fri Feb 20) JMIC - Jummah`,
    "link": `https://share.google/mD6IiCiAyF2LQx1JF`
  }, {
    "key": "northwood",
    "label": `(Tue Feb 24) Northwood - Taraweeh`,
    "link": `https://share.google/XiwUdApqLqcF19KFi`
  }, {
    "key": "barnhill",
    "label": `(Fri Feb 27) Barnhill - Jummah`,
    "link": `https://www.alfalahcentre.co.uk/`
  }, {
    "key": "northolt",
    "label": `(Saturday Feb 28) Northholt - Taraweeh`,
    "link": `https://share.google/lkQSfRvqJsj9wyDZd`
  }, {
    "key": "cjm",
    "label": `(Sun Mar 1) CJM - Taraweeh`,
    "link": `https://share.google/qOogKAlPNdtwqqtHn`
  }, {
    "key": "hayes",
    "label": `(Sat Mar 7) Hayes Mosque - Zuhr to Taraweeh`,
    "link": `https://share.google/m1RWmua5nsdn9DNDi`
  }]
}, {
  "key": "iftars",
  "label": "I want to help with iftars"
}, {
  "key": "eid",
  "label": "I would like to help on the day of eid",
  "options": [{
    "key": "fridayeid",
    "label": `I'm available if eid is on Thursday/Friday`,
  }, {
    "key": "saturdayeid",
    "label": `I'm available if eid is on Saturday`,
  }]
}, {
  "key": "finance",
  "label": "I want to help with the finances of the masjid"
}, {
  "key": "construction",
  "brotherOnly": true,
  "label": "I want to help with the masjid construction"
},  {
  "key": "academy",
  "label": "I want to help the academy"
}, {
  "key": "events",
  "label": "I want to help with events",
  "options": [{
    "key": "setup",
    "label": `Setup/Cleanup of Events`,
  }, {
    "key": "video",
    "label": `Video recording/editing`,
  }, {
    "key": "online",
    "label": `Social Media`,
  }]
}, {
  "key": "jummahs",
  "brotherOnly": true,
  "label": "I want to help during Jummah prayers",
  "options": [{
    "key": "firstJummah",
    "label": `First Jummah (12PM-1PM)`,
  }, {
    "key": "secondJummah",
    "label": `Second Jummay (1PM-1:45PM)`,
  }]
}, {
  "key": "coffeemornings",
  "sisterOnly": true,
  "label": "I want to help with Coffee mornings"
}]

const Donate = (props) => {
  
  const { ReactGA, selectMenu } = props;
  const [loading, setLoading] = useState(true);  
  const [submitted, setSubmitted] = useState(false);  
  const [gender, setGender] = useState(null);  
  const [name, setName] = useState('');  
  const [phone, setPhone] = useState('');  

  const [tasks, setTasks] = useState({});
  
  const toggleTasks = (key) => {
    if (tasks[key] === undefined) {
      tasks[key] = {
        selected: true,
        options: {}
      };
    }
    else {
      tasks[key] = {
        selected: !tasks[key].selected,
        options: {}
      };
    }
    setTasks({
      ...tasks
    })  
  }

  const toggleSubTasks = (parent, key) => {
    if (tasks[parent].options[key] === undefined) {
      tasks[parent].options[key] = true;
    }
    else {
      tasks[parent].options[key] = !tasks[parent].options[key];
    }
    setTasks({
      ...tasks
    })  
  }
  
  const [other, setOther] = useState(false);  
  const [otherSpecify, setOtherSpecify] = useState('');  

  const [ confirm, setConfirm ] = useState(false);
  const [ inited, setInited ] = useState(false);
  
  useEffect(() => {
    if (!inited) {
      setInited(true);
      setLoading(false);
    }    
  }, [inited, setInited]); // Or [] if effect doesn't need props or state

  function handleClick() {
    setLoading(true);
    const type = 'Volunteer';
    ReactGA.event({
      category: type,
      action: type,
    });
    return postResult({
      type,
      name,
      phone,
      tasks
    }).then(() => {
      setSubmitted(true);
      setLoading(false);
    })    
  }

  const disabled = !gender || !name || !phone || !confirm

  return loading ? <Loading/> : (<>
    <Container>   
    <h2>Volunteer at Al-Falah</h2>
    {submitted ? <>
      Jazakallah khairun for your support!<br/><br/>
      <Button variant="primary" type="submit" onClick={() => selectMenu('')}>
        Return to Main Menu
      </Button>
      <br/><br/>We will be in contact shortly.
    </>
    :<Form>
      <p>Please complete the form below to let us know about the way you would like to volunteer at Al-Falah</p>
      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label>I am:</Form.Label>
        <Form.Check
          key={"brother"}
          type="radio"
          name="taskOptions" // same name = radio group
          id={`radio-brother`}
          label={"a Brother"}
          checked={gender === "brother"}
          onChange={() => setGender("brother")}
        />
        <Form.Check
          key={"sister"}
          type="radio"
          name="taskOptions" // same name = radio group
          id={`radio-sister`}
          label={"a Sister"}
          checked={gender === "sister"}
          onChange={() => setGender("sister")}
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label>Enter your full name:</Form.Label>
        <Form.Control type="text" placeholder="Full name" onChange={(ev) => setName(ev.target.value)} value={name}/>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formPhoneNumber">
        <Form.Label>Enter your phone number (Whatsapp):</Form.Label>
        <Form.Control type="text" placeholder="Phone number"  onChange={(ev) => setPhone(ev.target.value)} value={phone}/>
      </Form.Group>

      {gender && activities.map((option) => {
        return ((!option.brotherOnly || gender === "brother") && (!option.sisterOnly || gender === "sister")) && <>         
        <Form.Group className="mb-3" controlId="formBasicCheckbox">
          <Form.Check type="checkbox" onClick={() => toggleTasks(option.key)} label={option.label} />
        </Form.Group>
        <ul class="no-bullet">
        {tasks[option.key]?.selected && option.options?.map((suboption) => {
            const label = suboption.link 
              ? (<a target={`_blank`} href={suboption.link}>{suboption.label}</a>)
              : suboption.label

            return <li><Form.Group className="mb-3" controlId="formBasicCheckbox">
              <Form.Check type="checkbox" onClick={() => toggleSubTasks(option.key, suboption.key)} label={label} />
            </Form.Group></li>
         })}
         </ul>
      </> 
      })}
        
      <Form.Group className="mb-3" controlId="formBasicCheckbox">
        <Form.Check type="checkbox" onClick={() => setOther(!other)} label="I can help in other ways" />
      </Form.Group>

      {other && <>
        <Form.Group className="mb-3" controlId="formPhoneNumber">
        <Form.Label>Please let us know how you can help us</Form.Label>
        <Form.Control as="textarea" rows={3} placeholder=""  onChange={(ev) => setOtherSpecify(ev.target.value)} value={otherSpecify}/>
      </Form.Group>
      </>}
      <br/><br/>

      <Form.Group className="mb-3" controlId="formBasicCheckbox">
        <Form.Check type="checkbox" onClick={() => setConfirm(!confirm)} label={(<>I confirm that I will read and agree to the policies found on the Al-Falah <a target={`_blank`} href={`https://www.alfalahcentre.org/donation/volunteer/`}>Volunteer Page</a></>)} />
      </Form.Group>


      <Button variant="primary" type="submit" onClick={handleClick} disabled={disabled}>
        Submit
      </Button>
    </Form>}       
    </Container>
    </>
);
}

export default Donate;
